export default __webpack_public_path__ + "static/media/amealogo.357ce3a6.png";